import React from "react";
import { useRef } from "react";
import {
  ExcelExport,
  ExcelExportColumn,
} from "@progress/kendo-react-excel-export";
import { confirmAlert } from "react-confirm-alert";
import { useTranslation } from "react-i18next";
import { formatDate } from "@progress/kendo-intl";

const ExportExcel = (props) => {
  const { t } = useTranslation();
  const _export = useRef(null);
  async function exportExcel() {
    if (_export !== null) {
      confirmAlert({
        title: "Uyarı",
        message:
          "Listelenen veri sayısına göre işlem süresi uzayabilir. Devam etmek istiyor musunuz?",
        buttons: [
          {
            label: "Evet",
            onClick: async () => {
              props.loadingFunction(true);
              try {
                var data = await props.serviceMethod(props.dataState);

                var dateColumns = props.columns
                  .filter((a) => a.type === "date")
                  .map((a) => a.field);
                var dateTimeColumns = props.columns
                  .filter((a) => a.type === "datetime")
                  .map((a) => a.field);

                data.data.map((a) => {
                  dateColumns?.forEach((elem) => {
                    if (a[elem])
                      a[elem] = formatDate(
                        new Date(a[elem]),
                        t("date_formats.shortDate")
                      );
                  });
                  dateTimeColumns?.forEach((elem) => {
                    if (a[elem])
                      a[elem] = formatDate(
                        new Date(a[elem]),
                        t("date_formats.longDateTime")
                      );
                  });
                  return a;
                });

                _export.current.save(data.data);
              } catch (err) {
                props.loadingFunction(false);
              }
            },
          },
          {
            label: "Hayır",
            onClick: () => {
              props.loadingFunction(false);
            },
          },
        ],
      });
    }
  }

  function onExportComplete() {
    props.loadingFunction(false);
  }

  return (
    <div>
      {" "}
      <ExcelExport
        data={props.data}
        ref={_export}
        onExportComplete={onExportComplete}
        fileName={`${props.fileName}_${formatDate(
          new Date(),
          t("date_formats.excelExport")
        )}`}
      >
        {props.columns.map((column, index) => (
          <ExcelExportColumn
            key={"column_" + index.toString()}
            field={column.field}
            title={t(column.title) ? t(column.title) : column.title}
            width={200}
          />
        ))}
      </ExcelExport>
      <button
        title="Export Excel"
        className="btn btn-success btn-sm"
        onClick={exportExcel}
      >
        <i className="k-icon k-i-excel"></i> Excel
      </button>
    </div>
  );
};

export default ExportExcel;
